import axios, { AxiosResponse } from "axios";
import {
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { User } from "../models/user";
import { toast } from "react-toastify";

interface SignInRequest {
  login: string;
  password: string;
}

interface AuthContextProps {
  signIn: (data: SignInRequest) => Promise<AxiosResponse<any, any>>;
  user: User | null;
  logOut: () => void;
}

const AuthContext = createContext({} as AuthContextProps);

export function AuthContextProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const currentUserOnStorage = localStorage.getItem("@user");
    if (currentUserOnStorage) {
      const currentUser = JSON.parse(currentUserOnStorage);

      setUser({
        name: currentUser.Nome,
        token: currentUser.Token,
        userId: currentUser.UsuarioId,
      });
    }
  }, []);

  async function signIn({ login, password }: SignInRequest) {
    const res = await axios.post(
      "https://poc.syncplatform.com.br/Demo/Api/ObterComplementosDaConta",
      {
        login,
        chave: password,
      },
      {
        headers: {
          "Content-Type": "application/json;",
          servicoToken: ")yGrgeNdR(U79(6",
          login: "mobile",
        },
      }
    );

    if (!res.data.success) {
      toast.error(res.data.message);
    }

    localStorage.setItem("@user", JSON.stringify(res.data));
    localStorage.setItem("@username", login);
    setUser({
      name: res.data.Nome,
      token: res.data.Token,
      userId: res.data.UsuarioId,
    });

    return res;
  }

  function logOut() {
    localStorage.removeItem("@user");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ signIn, user, logOut }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
